// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/pharmacyList/PharmacyList.css
// module id = 264
// module chunks = 0